import { Mail, MessageSquarePlus, Rss } from "lucide-react";

import { cn } from "@runcheetah/ui";

type IntegrationChannelIconId =
  | "instagram"
  | "linkedin"
  | "x"
  | "tiktok"
  | "blog"
  | "email"
  | "request";

const ICON_STROKE_WIDTH = 1.9;
const LOGO_SOURCES = {
  instagram: "/instagram.svg",
  linkedin: "/linkedin.svg",
  x: "/x.svg",
  tiktok: "/tiktok.svg",
} as const;

const ICONS = {
  blog: Rss,
  email: Mail,
  request: MessageSquarePlus,
} as const;

export function IntegrationChannelIcon({
  channelId,
  className = "h-5 w-5",
}: {
  channelId: IntegrationChannelIconId;
  className?: string;
}) {
  switch (channelId) {
    case "instagram":
    case "linkedin":
    case "x":
    case "tiktok":
      return (
        <img
          src={LOGO_SOURCES[channelId]}
          alt=""
          aria-hidden="true"
          className={cn("object-contain", className)}
        />
      );
    case "blog":
    case "email":
    case "request": {
      const Icon = ICONS[channelId];

      return <Icon aria-hidden="true" className={className} strokeWidth={ICON_STROKE_WIDTH} />;
    }
    default:
      return null;
  }
}
